<mat-toolbar color='primary'  class="example-footer">
  <mat-toolbar-row>
    <mat-icon class="example-icon" aria-hidden="false" aria-label="Example user verified icon">grade</mat-icon>
    <span class="example-spacer"></span>
    <button mat-flat-button color="primary" (click)="onNavigate()">{{ credit }} &#10084; {{ language }}</button>
  </mat-toolbar-row>
</mat-toolbar>
